import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './theme/theme-provider';
import { AuthProvider } from './context/AuthContext';
import { PostHogProvider } from './lib/posthog';
import { GleapProvider } from './lib/gleap/GleapProvider';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <PostHogProvider>
          <AuthProvider>
            <GleapProvider>
              <App />
            </GleapProvider>
          </AuthProvider>
        </PostHogProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
